import { axios } from '@/utils/request'

const api = {
  enterpriseManagement: '/enterprise/management'
}

// 获取企业黑名单列表
export function getEnterpriseManagement(parameter) {
  return axios({
    url: api.enterpriseManagement + '/listBlack',
    method: 'get',
    params: parameter
  })
}

// 获取企业列表
export function getEnterpriseSelectCombox(query) {
  return axios({
    url: api.enterpriseManagement + '/selectCombox',
    method: 'get',
    params: query
  })
}

// 新增用户对应锁企权限
export function addUserPermissionOfEnterprise(data) {
  return axios({
    url: '/system/user/addUserPermissionOfEnterprise',
    method: 'post',
    data: data
  })
}
